if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.buttonText = this.querySelector('.sticky-add-to-cart__button-text');
        this.priceElement = this.querySelector('.sticky-add-to-cart__price');
        this.sectionId = this.dataset.sectionId;

        this.originalAddToCartButton = null;
        this.productForm = null;

        this.init();
      }

      init() {
        // Find the original product form
        this.productForm = document.querySelector(`product-info[data-section="${this.sectionId}"] product-form`);

        if (this.productForm) {
          this.originalAddToCartButton = this.productForm.querySelector('[type="submit"]');
        }

        // Set up intersection observer to show/hide sticky bar
        this.setupIntersectionObserver();

        // Set up click handler
        this.button.addEventListener('click', this.onButtonClick.bind(this));

        // Subscribe to variant changes to update button state and price
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      setupIntersectionObserver() {
        if (!this.originalAddToCartButton) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Show sticky bar when original button is not visible
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0,
          }
        );

        observer.observe(this.originalAddToCartButton);
      }

      onButtonClick(evt) {
        evt.preventDefault();

        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        // Trigger click on the original form's submit button
        if (this.productForm) {
          const originalSubmit = this.productForm.querySelector('[type="submit"]');
          if (originalSubmit) {
            // Show loading state on sticky button
            this.button.setAttribute('aria-disabled', true);
            this.button.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            // Submit the original form
            const form = this.productForm.querySelector('form');
            if (form) {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }

            // Reset loading state after a delay (the cart drawer will open)
            setTimeout(() => {
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            }, 1500);
          }
        }
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const variant = event.data.variant;

        if (!variant) {
          this.button.disabled = true;
          this.buttonText.textContent = window.variantStrings.unavailable;
          return;
        }

        if (!variant.available) {
          this.button.disabled = true;
          this.buttonText.textContent = window.variantStrings.soldOut;
        } else {
          this.button.disabled = false;
          this.buttonText.textContent = window.variantStrings.addToCart;
        }

        // Update price
        this.updatePrice(variant);
      }

      updatePrice(variant) {
        if (!this.priceElement || !variant) return;

        let priceHtml = '';

        if (variant.compare_at_price > variant.price) {
          priceHtml += `<s class="sticky-add-to-cart__compare-price">${this.formatMoney(variant.compare_at_price)}</s>`;
        }

        priceHtml += this.formatMoney(variant.price);
        this.priceElement.innerHTML = priceHtml;
      }

      formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
        }
        // Fallback formatting
        return '$' + (cents / 100).toFixed(2);
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
    }
  );
}
